import ListView from 'view/listView';

class TicketListView extends ListView {
  constructor() {
    super();
    this.name = 'ticket';
    this.className = 'TicketListView';
  }
}
export default TicketListView;